var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loni-checkbox",class:{disabled:_vm.disabledValue},style:({
         color: _vm.textColor,
         fontSize: _vm.options.size
     }),on:{"click":_vm.change}},[_c('i',{staticClass:"loni",class:[_vm.checked?_vm.options.checkedIcon:_vm._uncheckIcon,{margin:_vm.$slots.default}],style:({color:_vm.checked?_vm._checkedColor:_vm._uncheckColor})}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }